module.exports = __webpack_public_path__ + "static/media/precon.2e7656eb.svg";